import React, { useState } from 'react';
import PageHeader from '../components/layout/PageHeader';
import Button from '../components/ui/Button';
import { CalendarIcon, ClockIcon, MapPinIcon, UsersIcon } from 'lucide-react';
const AlumniEvents = () => {
  const upcomingEvents = [{
    id: 1,
    title: 'Annual Alumni Reunion',
    date: 'December 15, 2023',
    time: '12:00 PM - 6:00 PM',
    location: 'School Grounds',
    image: 'https://images.unsplash.com/photo-1511578314322-379afb476865?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1769&q=80',
    description: 'Join us for our annual alumni reunion featuring networking, campus tours, and a gala dinner.',
    organizer: 'Alumni Association',
    registrationFee: '₦5,000',
    registrationRequired: true
  }, {
    id: 2,
    title: 'Class of 1997 Silver Jubilee',
    date: 'November 25, 2023',
    time: '4:00 PM - 10:00 PM',
    location: 'Imperial Hotel, Ijebu-Ode',
    image: 'https://images.unsplash.com/photo-1505373877841-8d25f7d46678?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1712&q=80',
    description: '25th anniversary celebration and fundraising dinner for the Class of 1997.',
    organizer: 'Class of 1997 Set',
    registrationFee: '₦10,000',
    registrationRequired: true
  }, {
    id: 3,
    title: 'Alumni Mentorship Day',
    date: 'January 20, 2024',
    time: '10:00 AM - 2:00 PM',
    location: 'School Hall',
    image: 'https://images.unsplash.com/photo-1517486808906-6ca8b3f8e1c1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1749&q=80',
    description: 'Alumni from various professions return to mentor current students on career choices and opportunities.',
    organizer: 'Alumni Association & Guidance Counseling Department',
    registrationFee: 'Free',
    registrationRequired: true
  }, {
    id: 4,
    title: "Founders' Day 2024",
    date: 'February 15, 2024',
    time: '9:00 AM - 4:00 PM',
    location: 'School Campus',
    image: 'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80',
    description: "Special alumni participation in Founders' Day celebrations, including the Distinguished Alumni Award ceremony.",
    organizer: 'School Administration & Alumni Association',
    registrationFee: 'Free',
    registrationRequired: false
  }];
  const pastEvents = [{
    id: 5,
    title: 'Alumni Sports Festival',
    date: 'August 12, 2023',
    image: 'https://images.unsplash.com/photo-1526232761682-d26e03ac148e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1829&q=80',
    description: 'A day of friendly sports competitions between different alumni sets.'
  }, {
    id: 6,
    title: 'Class of 1983 Reunion',
    date: 'July 22, 2023',
    image: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80',
    description: '40th anniversary celebration of the Class of 1983.'
  }, {
    id: 7,
    title: 'Alumni Career Fair',
    date: 'May 15, 2023',
    image: 'https://images.unsplash.com/photo-1560523159-4a9692d222f9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1742&q=80',
    description: 'Alumni-led career fair for graduating students.'
  }];
  const [selectedEvent, setSelectedEvent] = useState<number | null>(null);
  const handleEventClick = (id: number) => {
    setSelectedEvent(id === selectedEvent ? null : id);
  };
  const formatDate = (dateString: string) => {
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };
  return <div className="min-h-screen bg-white" data-id="element-3098">
      <PageHeader title="Alumni Events" description="Stay connected with your alma mater through our alumni events and reunions." backgroundImage="https://images.unsplash.com/photo-1511578314322-379afb476865?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1769&q=80" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'Alumni',
      path: '/alumni'
    }, {
      label: 'Events',
      path: '/alumni/events'
    }]} data-id="element-3099" />
      <div className="container mx-auto px-4 py-12" data-id="element-3100">
        <div className="text-center mb-10" data-id="element-3101">
          <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-3102">
            Upcoming Alumni Events
          </h2>
          <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-3103"></div>
          <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-3104">
            Connect with fellow alumni, give back to your alma mater, and stay
            involved with the IGS community through our exciting events.
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16" data-id="element-3105">
          {upcomingEvents.map(event => <div key={event.id} className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-3106">
              <div className="md:flex" data-id="element-3107">
                <div className="md:w-2/5" data-id="element-3108">
                  <img src={event.image} alt={event.title} className="w-full h-full object-cover" data-id="element-3109" />
                </div>
                <div className="md:w-3/5 p-6" data-id="element-3110">
                  <div className="flex items-center text-sm text-gray-500 mb-2" data-id="element-3111">
                    <CalendarIcon className="h-4 w-4 mr-1" data-id="element-3112" />
                    <span data-id="element-3113">{formatDate(event.date)}</span>
                  </div>
                  <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-3114">
                    {event.title}
                  </h3>
                  <p className="text-gray-700 mb-4" data-id="element-3115">{event.description}</p>
                  <div className="flex flex-wrap gap-4 text-sm text-gray-600 mb-4" data-id="element-3116">
                    <div className="flex items-center" data-id="element-3117">
                      <ClockIcon className="h-4 w-4 mr-1" data-id="element-3118" />
                      <span data-id="element-3119">{event.time}</span>
                    </div>
                    <div className="flex items-center" data-id="element-3120">
                      <MapPinIcon className="h-4 w-4 mr-1" data-id="element-3121" />
                      <span data-id="element-3122">{event.location}</span>
                    </div>
                    <div className="flex items-center" data-id="element-3123">
                      <UsersIcon className="h-4 w-4 mr-1" data-id="element-3124" />
                      <span data-id="element-3125">{event.organizer}</span>
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-2" data-id="element-3126">
                    <Button onClick={() => handleEventClick(event.id)} variant="outline" size="sm" data-id="element-3127">
                      {selectedEvent === event.id ? 'Hide Details' : 'Event Details'}
                    </Button>
                    {event.registrationRequired && <Button onClick={() => alert(`Registration form for ${event.title} would open here`)} variant="primary" size="sm" data-id="element-3128">
                        Register Now
                      </Button>}
                  </div>
                  {selectedEvent === event.id && <div className="mt-4 pt-4 border-t border-gray-200 animate-fadeIn" data-id="element-3129">
                      <h4 className="font-bold text-blue-900 mb-2" data-id="element-3130">
                        Event Details
                      </h4>
                      <ul className="space-y-2 text-gray-700" data-id="element-3131">
                        <li className="flex items-start" data-id="element-3132">
                          <div className="font-medium w-32" data-id="element-3133">Date:</div>
                          <div data-id="element-3134">{formatDate(event.date)}</div>
                        </li>
                        <li className="flex items-start" data-id="element-3135">
                          <div className="font-medium w-32" data-id="element-3136">Time:</div>
                          <div data-id="element-3137">{event.time}</div>
                        </li>
                        <li className="flex items-start" data-id="element-3138">
                          <div className="font-medium w-32" data-id="element-3139">Location:</div>
                          <div data-id="element-3140">{event.location}</div>
                        </li>
                        <li className="flex items-start" data-id="element-3141">
                          <div className="font-medium w-32" data-id="element-3142">Organizer:</div>
                          <div data-id="element-3143">{event.organizer}</div>
                        </li>
                        <li className="flex items-start" data-id="element-3144">
                          <div className="font-medium w-32" data-id="element-3145">
                            Registration Fee:
                          </div>
                          <div data-id="element-3146">{event.registrationFee}</div>
                        </li>
                      </ul>
                      <div className="mt-4 bg-yellow-50 p-3 rounded-lg border border-yellow-100" data-id="element-3147">
                        <p className="text-sm text-gray-700" data-id="element-3148">
                          <span className="font-medium" data-id="element-3149">Note:</span> Please
                          bring your alumni ID or any form of identification for
                          this event. For inquiries, contact
                          alumni@isonyingrammarschool.edu.ng.
                        </p>
                      </div>
                    </div>}
                </div>
              </div>
            </div>)}
        </div>
        <div className="text-center mb-10" data-id="element-3150">
          <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-3151">Past Events</h2>
          <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-3152"></div>
          <p className="mt-4 text-gray-600 max-w-2xl mx-auto" data-id="element-3153">
            Take a look at our previous alumni events and activities.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-3154">
          {pastEvents.map(event => <div key={event.id} className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-3155">
              <img src={event.image} alt={event.title} className="w-full h-48 object-cover" data-id="element-3156" />
              <div className="p-6" data-id="element-3157">
                <div className="flex items-center text-sm text-gray-500 mb-2" data-id="element-3158">
                  <CalendarIcon className="h-4 w-4 mr-1" data-id="element-3159" />
                  <span data-id="element-3160">{formatDate(event.date)}</span>
                </div>
                <h3 className="text-xl font-bold text-blue-900 mb-2" data-id="element-3161">
                  {event.title}
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-3162">{event.description}</p>
                <Button onClick={() => alert(`Photo gallery for ${event.title} would open here`)} variant="outline" size="sm" data-id="element-3163">
                  View Photo Gallery
                </Button>
              </div>
            </div>)}
        </div>
        <div className="bg-blue-900 text-white rounded-lg p-8 text-center" data-id="element-3164">
          <h3 className="text-2xl font-bold mb-4" data-id="element-3165">Suggest an Alumni Event</h3>
          <p className="mb-6 max-w-2xl mx-auto" data-id="element-3166">
            Have an idea for an alumni event? We welcome your suggestions!
            Whether it's a class reunion, networking event, or community service
            project, let us know.
          </p>
          <Button onClick={() => alert('Event suggestion form would open here')} variant="primary" className="bg-yellow-500 text-blue-900 hover:bg-yellow-400" data-id="element-3167">
            Suggest an Event
          </Button>
        </div>
      </div>
    </div>;
};
export default AlumniEvents;